import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';

export const ScrollLoaderDirectiveModule = angular
    .module('app.directives.scrollLoader', [])
    .directive('scrollLoader', ($window, $document) => {
        return function(scope) {
            let mainWindow = angular.element($window);

            const checkScrollPosition = throttle(() => {
                if (mainWindow.scrollTop() + mainWindow.height() > $document.height() - 100) {
                    loadMore();
                }
            }, 200);

            // only allow this to fire twice per second
            const loadMore = debounce(() => {
                let gridOptions = scope.$ctrl ? scope.$ctrl.grid.options : scope.grid.options;

                if (gridOptions.paging.currentPage < gridOptions.paging.pageCount) {
                    gridOptions.scrollLoader = true;
                    gridOptions.next();
                }
            }, 500, true);

            mainWindow.on('scroll', checkScrollPosition);
            checkScrollPosition();

            scope.$on('$destroy', () => {
                mainWindow.off('scroll', checkScrollPosition);
            });
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/scrollLoader.directive.js